module.exports = __webpack_public_path__ + "img/img1.93027850.png";